<template>
    <app-content-admin>
        <template slot="header">User</template>
        <template>
            <v-row align="center">
                <v-col cols="10">
                    <v-text-field
                        v-model="searchTerm"
                        label="Email "
                        outlined
                        clearable
                        solo-inverted
                        full-width
                    ></v-text-field>
                </v-col>
                <v-col cols="2">
                    <v-btn @click="userListData" class="ma-2">Search</v-btn>
                </v-col>
            </v-row>
        </template>
        <template slot="button">
            <v-btn
                style="margin-left: auto"
                large
                color="primary"
                to="/user/add_user"
            >
                + Add User
            </v-btn>
        </template>

        <v-layout row wrap>
            <v-flex xs12>
                <v-card class="p-3">
                    <table class="table table-fluid no-wrap">
                        <thead>
                            <th scope="col">User Id</th>
                            <th scope="col">Firstname</th>
                            <th scope="col">Lastname</th>
                            <th scope="col">Email</th>
                            <th scope="col">Role</th>
                            <th scope="col">Action</th>
                        </thead>
                        <tbody>
                            <tr
                                class="text-center"
                                v-for="(user, i) in displayedItems"
                                :key="i"
                            >
                                <td :data-label="$t('User ID')">
                                    {{ user.id_user }}
                                </td>
                                <!-- <td :data-label="$t('Project ID')" class="text-truncate">{{ user.id_project }}</td> -->
                                <td
                                    :data-label="$t('Firstname')"
                                    class="text-truncate"
                                >
                                    {{ user.firstname }}
                                </td>
                                <td
                                    :data-label="$t('Lastname')"
                                    class="text-truncate"
                                >
                                    {{ user.lastname }}
                                </td>

                                <td :data-label="$t('Email')">
                                    {{ user.email }}
                                </td>
                                <td :data-label="$t('Role')">
                                    {{ user.roles }}
                                </td>
                            
                                <td
                                    :data-label="$t('action')"
                                    v-if="user.roles !== 'admin'"
                                >
                                    <v-menu
                                        :close-on-content-click="true"
                                        :nudge-width="200"
                                        :open-on-click="true"
                                        offset-y
                                        offset-x
                                        left
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                color="primary"
                                                text
                                                small
                                                icon
                                                v-on="on"
                                            >
                                                <v-icon>more_horiz</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-item
                                                @click="
                                                    ViewUserDetail(user.id_user)
                                                "
                                            >
                                                <v-list-item-action>
                                                    Edit
                                                </v-list-item-action>
                                            </v-list-item>
                                            <v-list-item
                                                @click="goToReset(user.id_user)"
                                            >
                                                <v-list-item-action>
                                                    Reset Password
                                                </v-list-item-action>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <!-- Confirmation Dialog -->
                    <v-dialog v-model="showConfirmationDialog" max-width="400">
                        <v-card>
                            <v-card-title>Confirm Deletion</v-card-title>
                            <v-card-text>
                                Are you sure you want to delete this user?
                            </v-card-text>
                            <v-card-actions>
                                <v-btn
                                    color="primary"
                                    @click="deleteUser(userToDelete)"
                                >
                                    Yes
                                </v-btn>
                                <v-btn @click="cancelDelete">No</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-card>
                <v-pagination
                    class="pagination mb-2"
                    v-model="currentPage"
                    :length="totalPages"
                    @input="updatePage"
                    :total-visible="7"
                ></v-pagination>
            </v-flex>
        </v-layout>
    </app-content-admin>
</template>

<script>
import vForm from "@/mixins/vForm";
import ActiveLabel from "../../components/status/ActiveLabel.vue";
import store from "@/store";

export default {
    mixins: [vForm],

    data() {
        return {
            users: [],
            form: {
                page: 1,
                offset: 10,
            },
            itemsPerPage: 10,
            currentPage: 1,

            showDialog: false,
            showConfirmationDialog: false, // Initialize to false
            userToDelete: null, // Store the selected user for deletion
        };
    },

    components: { ActiveLabel },

    computed: {
        totalPages() {
            return Math.ceil(this.users.length / this.itemsPerPage);
        },
        displayedItems() {
            const startIndex = (this.currentPage - 1) * this.itemsPerPage;
            const endIndex = startIndex + this.itemsPerPage;
            console.log(endIndex);
            return this.users.slice(startIndex, endIndex);
        },
    },

    created() {
        this.userListData();
    },

    methods: {
        //Pagination
        updatePage(page) {
            this.currentPage = page;
        },

        onListChange(page) {
            this.userListData(10, page);
        },
        
        //Read all user data
        userListData() {
            let loader = this.$loading.show();
            let token = store.getters["auth/token"];
            axios
                .get(`/api/auth/get_user_list`,{
                    params: {
                        search_term: this.searchTerm
                    }})
                .then((res) => res.data)
                .then((res) => {
                    this.users = res.data.result;
                    console.log(this.users);
              
                })
                .catch((e) => {
                    this.$toastr.e(e.message);
                })
                .finally(() => {
                    loader.hide();
                });
        },

        
       //Delete specific user data
        async deleteUser(id) {
            let loader = this.$loading.show();

            try {
                let token = store.getters["auth/token"];
                let res = await axios.post(`/api/auth/delete_user`, {
                    id_user: id,
                });

                // Log the response for debugging
                console.log("Delete User API Response:", res);

                if (res.data) {
                    this.$toastr.s("Delete successfully");
                    // Close the confirmation dialog and return to the /user path
                    this.cancelDelete();
                    this.$router.push({ path: "/user" });
                }
            } catch (e) {
                console.error("Error deleting user:", e);

                this.$toastr.e(e.message);
            } finally {
                loader.hide();
                this.userListData();
            }
        },
        
        //Edit user frontend route
        ViewUserDetail(id) {
            this.$router.push({ path: "/user/view_user/" + id });
        },
        
        //Reset user password frontend route
        goToReset(id) {
            this.$router.push({ path: "/user/reset_password/" + id });
        },
        
        //Delete dialog
        selectUserToDelete(id) {
            // Store the user data to delete
            this.userToDelete = id;

            // Open the confirmation dialog
            this.showConfirmationDialog = true;
        },
        cancelDelete() {
            // Reset the data and close the confirmation dialog
            this.showConfirmationDialog = false;
            this.userToDelete = null;
        },
    },
};
</script>
